import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import CardEmpty from "Utils/Cards/CardEmpty";
import Paginacion from "../../../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../../../Utils/LoadMask/LoadMask";
import { FiltrosTurnosFinalizados } from "./components/FiltrosTurnosFinalizados";
import { TurnosFinalizadosTable } from "./components/TurnosFinalizadosTable";
import { useDebounce } from "../../../../../../../Utils/Hooks/useDebounce";
import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../../../utility/utils";
import { TurnosProduccionApi } from "../../api/TurnosProduccionApi";
import { DecisionSwal } from "../../../../../../../Utils/Utils/DecisionSwal";

export const TurnosFinalizadosTab = ({ storageKey, mostrarTabTurnoActual }) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const searchDefault = filtros.search || "";
    const fechaInicialDefault = filtros.fecha_inicial
        ? moment(filtros.fecha_inicial)
        : null;

    const fechaFinalDefault = filtros.fecha_final
        ? moment(filtros.fecha_final)
        : null;

    const { control, watch } = useForm({
        defaultValues: {
            search: searchDefault,
            fecha_inicial: fechaInicialDefault,
            fecha_final: fechaFinalDefault,
        },
    });

    const [turnosFinalizados, setTurnosFinalizados] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);
    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");

    const { getTurnosFinalizados, reabrirTurno, cargando } =
        TurnosProduccionApi();

    const GetTurnosFinalizados = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            if (fecha_inicial) {
                params.fecha_inicial = dateToDayStart(fecha_inicial);
            }

            if (fecha_final) {
                params.fecha_final = dateToDayEnd(fecha_final);
            }

            const response = await getTurnosFinalizados(params);
            setTurnosFinalizados(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener turnos finalizados",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setTurnosFinalizados([]);
            setCantidadResultados(0);
        }
    };

    const ReabrirTurno = async (turno) => {
        try {
            await reabrirTurno(turno.id);

            NotificationManager.success(
                "Turno reabierto correctamente",
                "Éxito",
                3000,
            );

            if (mostrarTabTurnoActual) mostrarTabTurnoActual();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al reabrir el turno",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        } finally {
            GetTurnosFinalizados();
        }
    };

    const MostrarMensajeReaperturaTurno = (turno) => {
        let mensaje = "¿Está seguro de reabrir este turno?";
        mensaje +=
            "\n\nVolverá a quedar como turno activo y se borrarán los sobrantes que reportó al cerrarlo.";

        if (turno.sobrante_enviado_bodega) {
            mensaje +=
                " Ese sobrante ya entró a bodega, así que también se restará del inventario de bodega.";
        }

        DecisionSwal(mensaje, "Sí", "No", () => ReabrirTurno(turno));
    };

    useEffect(() => {
        GetTurnosFinalizados();
    }, [paginaSeleccionada, debouncedSearch, fecha_inicial, fecha_final]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                search: debouncedSearch,
                fecha_inicial,
                fecha_final,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [debouncedSearch, fecha_inicial, fecha_final, paginaSeleccionada]);

    return (
        <div className="turnos-produccion__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="turnos-produccion__table-header">
                        <FiltrosTurnosFinalizados
                            control={control}
                            onRefresh={() => {
                                GetTurnosFinalizados();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"Supervisor, operador"}
                        />
                    </div>

                    <TurnosFinalizadosTable
                        turnosFinalizados={turnosFinalizados}
                        ReabrirTurno={MostrarMensajeReaperturaTurno}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
